import { userService } from "../services";
import config from "../config/config";

export const PermissionMasterAction = {
  getCompanyWiseUser,
  getUserPermissionByUserId,
  getAllPermission,
};

async function getCompanyWiseUser(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getCompanyWiseUser}`;
    let response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}

async function getUserPermissionByUserId(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getUserPermissionByUserId}`;
    let response = await userService.post(apiEndpoint, payload);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function getAllPermission() {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.getAllPermission}`;
    let response = await userService.get(apiEndpoint);
    if (response?.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
}
